<template>
  <v-dialog v-model="showModal" persistent>
    <v-card>
      <v-btn icon @click="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>
      <v-card-title class="headline">Selecione um cartão</v-card-title>
      <v-card-text>
        <!-- <v-carousel height="225">
          <v-carousel-item
            v-for="(card,key) in cards"
            :key="key"
          >
            <div class='card' @click="selectCard(card)">
              <div class='card-content'>
                  <div style="text-align:right">
                    <img v-if="card.flag=='Visa'" src="../../../images/card_logos/visa.svg" width="70" height="40">
                    <img v-if="card.flag=='Master'" src="../../../images/card_logos/mastercard.svg" width="70" height="40">
                    <img v-if="card.flag=='Amex'" src="../../../images/card_logos/amex.svg" width="70" height="40">
                    <img v-if="card.flag=='Discover'" src="../../../images/card_logos/discover.svg" width="70" height="40">
                    <img v-if="card.flag=='Elo'" src="../../../images/card_logos/elo.svg" width="70" height="40">
                    <img v-if="card.flag=='Hipercard'" src="../../../images/card_logos/hipercard.svg" width="70" height="40">
                  </div>

                  <h5>Card Number</h5>
                  <h6 id='label-cardnumb  er'>XXXX XXXX XXXX{{card.nickname.split('-')[1]}}</h6>
                  <h5>Expiration<span>CVC</span></h5>
                  <h6 id='label-cardexpiration'>XX / XXXX<span>XXX</span></h6>
                  <h5>{{card.credit_card_owner}}</h5>
              </div>
            </div>
          </v-carousel-item>
        </v-carousel> -->
        <v-card v-for="(card, index) in cards" :key="index">
          <v-btn @click="selectCard(card)" class="btnColorS ma-0 w-100 mt-3">
            <span class="white--text font-weight-bold">{{
              card.nickname
            }}</span>
            <!-- <v-spacer></v-spacer>
            <v-btn icon class="colorSelected" @click="selectCard(card)">
              <v-icon>check</v-icon>
            </v-btn> -->
          </v-btn>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="$emit('add-card')" class="btnColor ma-0 w-100 mt-3">
          <span class="font-weight-bold">ADICIONAR CARTÃO</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    cards: {
      required: true,
      type: Array,
    },
    showModal: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {};
  },
  methods: {
    selectCard(card) {
      this.$emit('selectCard', card);
    },
  },
};
</script>
<style scoped>
/*--------------------
Text
---------------------*/
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  line-height: 1.4;
}

h5 {
  font-size: 11px;
  font-weight: 700;
  color: #28282c;
  letter-spacing: 1px;
  text-align: left;
  text-transform: uppercase;
}

h5 > span {
  margin-left: 87px;
}

h5.total {
  margin-top: 20px;
}

h6 {
  font-family: 'PT Mono';
  font-size: 18px;
  font-weight: 400;
  color: #f4f5f9;
  letter-spacing: 0px;
  text-align: left;
  text-transform: uppercase;
  line-height: 1.8;
}

h6 > span {
  margin-left: 87px;
}

.card {
  width: 100%;
  height: 178px;
  position: relative;
  margin: 0 auto;
  background-color: #9a9a9a;
  overflow: hidden;
  z-index: 1;
}

.card-content {
  width: 100%;
  padding: 20px;
  position: relative;
  float: left;
  z-index: 1;
}

.card-form {
  width: 100%;
  position: relative;
  float: right;
  padding: 15px 35px;
}

.card-form > p.field {
  height: 48px;
  padding: 2px 10px;
  margin-bottom: 2px;
  background-color: #f4f5f9;
  border: 1px solid #d2d4de;
  display: inline-block;
}

#i-cardfront,
#i-cardback,
#i-calendar {
  position: relative;
  top: 8px;
  z-index: 1;
}

.btnColor {
  background-color: var(--secondary-color) !important;
  color: var(--primary-color) !important;
}

.btnColorS {
  background-color: var(--secondary-color) !important;
}
</style>
